import {Component, OnInit} from '@angular/core';
import {ProductsService} from "../../../../../../services/products/products.service";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {Product} from "../../../../../../models/Product";
import {WarehouseService} from "../../../../../../services/warehouse/warehouse.service";
import {StockService} from "../../../../../../services/stock/stock.service";

@Component({
    selector: 'app-logistic-info',
    templateUrl: './logistic-info.component.html',
    styleUrls: ['./logistic-info.component.scss']
})
export class LogisticInfoComponent implements OnInit {

    productId!: number;
    productData: any = {};
    entrepotName: string;
    /** total_quantity (GET /api/stock/product/:id après résolution id via /api/stock/products/product-id/:erpId) */
    totalQuantity: number | null = null;
    showEmptyStockAlert = false;

    constructor(private productsService: ProductsService,
                private route: ActivatedRoute,
                private warehouseService: WarehouseService,
                private toastr: ToastrService,
                private stockService: StockService) {
    }

    ngOnInit(): void {
        this.productId = +this.route.parent?.snapshot.paramMap.get('id')!;
        this.getProduct();
    }

    getProduct(): void {
        this.productsService.getDetailsProduct(this.productId).subscribe({
            next: (response: Product) => {
                this.productData = this.unwrapProductResponse(response);
                const infos = this.getInformationsLogistiqueArray(this.productData);
                const entrepotId = infos[0]?.entrepot_id ?? infos[0]?.entrepotId;
                if (entrepotId) {
                    this.loadEntrepotName(entrepotId);
                }
                this.loadTotalStockFromApi();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du produit');
            }
        });
    }

    private unwrapProductResponse(res: any): any {
        if (!res || typeof res !== 'object') {
            return {};
        }
        const inner = res.data ?? res.product ?? res.produit;
        if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
            return inner;
        }
        return res;
    }

    private getInformationsLogistiqueArray(p: any): any[] {
        if (!p) {
            return [];
        }
        const raw =
            p.informations_logistique ??
            p.information_logistique ??
            p.informationsLogistique ??
            p.product?.informations_logistique;
        return Array.isArray(raw) ? raw : [];
    }

    private isProductMaterial(p: any): boolean {
        const t = (p?.type ?? '').toString().trim().toLowerCase();
        return t === 'matériel' || t === 'materiel' || t === 'material';
    }

    private isLogisticAlertEnabled(line: any): boolean {
        if (!line || typeof line !== 'object') {
            return false;
        }
        const v = line.is_active_alert ?? line.is_active_alerte ?? line.active_alert;
        if (v === true || v === 1 || v === '1') {
            return true;
        }
        if (v === false || v === 0 || v === '0' || v === '') {
            return false;
        }
        return !!v;
    }

    private loadTotalStockFromApi(): void {
        this.stockService.getTotalStockByErpProductId(this.productId).subscribe({
            next: (qty: number) => {
                this.totalQuantity = qty;
                this.updateEmptyStockAlert();
            },
            error: () => {
                this.totalQuantity = 0;
                this.updateEmptyStockAlert();
            }
        });
    }

    private updateEmptyStockAlert(): void {
        const qty = this.totalQuantity == null || isNaN(Number(this.totalQuantity)) ? 0 : Number(this.totalQuantity);
        const logistics = this.getInformationsLogistiqueArray(this.productData);
        const isMaterial = this.isProductMaterial(this.productData);
        const alertOn = logistics.some((w) => this.isLogisticAlertEnabled(w));
        this.showEmptyStockAlert = isMaterial && alertOn && qty <= 0;
    }


    loadEntrepotName(entrepotId: number): void {
        const userId = this.productData.client_id;
        const stationId = this.productData.station_id;
        //console.log("response");
        this.warehouseService.detailEntrepot(entrepotId, userId, stationId).subscribe({
            next: (response: any) => {
                //console.log(response);
                this.entrepotName = response.entrepot?.nom || null;

            },
            error: () => {
                this.toastr.error("Erreur lors du chargement de l'entrepôt");
            }
        });
    }

}


